<template>
    <div class="app-comment-item">
        <div class="app-comment-item__avatar-box">
            <app-avatar :text="data.nickName"/>
        </div>
        <div class="app-comment-item__content-box">
            <div class="app-comment-item__meta-box">
                <span class="app-comment-item__user-name">{{data.nickName}}</span>
            </div>
            <div class="app-comment-item__content">{{data.content}}</div>
            <div class="app-comment-item__tools-box">
                <span class="app-comment-item__date">{{createDate}}</span>
                <app-button class="app-comment-item__replay"
                            @click.stop="handleReplayClick"
                >
                    <app-icon value="icon-interactive"/>
                    回复
                </app-button>
            </div>
            <!-- 回复 -->
            <div class="app-comment-item__comment"
                 v-if="replay"
            >
                <app-comment expand
                             :hostId="data.hostId"
                             :parentId="data.id"
                             @success="handleCommentSuccess"
                             @blur="handleCommentBlur"/>
            </div>
            <div class="app-comment-item__replay-list" v-if="children.length">
                <template v-for="item in children">
                    <comment-reply-item :key="item.id"
                                        :data="item"
                                        @comment-success="handleCommentSuccess"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import AppAvatar from '@components/AppAvatar'
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'
    import AppComment from '@components/AppComment'
    import CommentReplyItem from '../CommentReplyItem'

    import {formatDate} from '@utils'


    export default {
        name: "CommentItem",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                replay: false
            }
        },
        computed: {
            // 发布日期
            createDate() {
                const {data} = this
                const {createTime} = data || {}
                if (createTime) {
                    return formatDate(new Date(createTime), 'yyyy年MM月dd日 HH时mm分ss秒')
                }
                return '无'
            },
            children() {
                const {data} = this
                const {child} = data || {}
                return child || []
            }
        },
        methods: {
            handleReplayClick() {
                this.replay = true
            },
            handleCommentBlur() {
                this.replay = false
            },
            handleCommentSuccess() {
                console.log('CommentItem success')
                this.$emit('comment-success')
            }
        },
        components: {
            AppComment,
            AppIcon,
            AppButton,
            AppAvatar,
            CommentReplyItem
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .app-comment-item {
        position: relative;
        display: flex;
        flex-direction: row;

        &:not(:last-child) {
            margin-bottom: $paddingMD;
        }

        &__content-box {
            margin-left: $paddingMD;
            width: 100%;
            overflow: hidden;
        }

        &__meta-box {
            margin-bottom: $paddingSM;

        }

        &__user-name {
            font-size: $fontSize;
            font-weight: $fontWeightBolder;
            color: $primaryColor;
            color: var(--primaryColor);
            @include transition-colors;
        }


        &__tools-box {
            margin-top: $paddingSM;
            display: flex;
            justify-content: space-between;
        }

        &__date {
            font-size: $fontSizeSM;
            padding-right: $paddingBase;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &__replay {
            font-size: $fontSizeSM;
            white-space: nowrap;
            .app-icon {
                font-size: $fontSizeSM;
            }
        }


        &__comment {
            margin-top: $paddingMD;
        }

        &__replay-list {
            margin-top: $paddingMD;
            padding: $paddingBase $paddingMD;
            border-radius: $radius;
            overflow: hidden;
            background-color: $componentBackgroundColor;
            background-color: var(--componentBackgroundColor);
            @include transition-colors;
        }

        &__content-box {
            font-size: $fontSizeCommon;
            color: $textColor;
            color: var(--textColor);
            @include transition-colors;
        }

        // $fontSizeSM

    }
</style>